import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SidebarToggleButton, EditableTitle } from '../../molecules';
import { useSidebar } from '../../../providers';

const HeaderContainer = styled.div`
  display: flex;
  padding: 16px 24px;
  gap: 16px;
  justify-content: space-between;
  width: 100%;
  height: 77px;
  box-sizing: border-box;

  border-bottom: 1px solid var(--border-muted);

  @media (max-width: 768px) {
    padding: 16px;
    gap: 8px;
  }
`;

const HeaderInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2px;
  align-items: flex-start;
  justify-content: center;
`;

const HeaderActionsContainer = styled.div`
  display: flex;
  column-gap: 8px;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
`;

const StyledSidebarToggleButton = styled(SidebarToggleButton)`
  align-self: center;
`;

const Header = ({ title, isReadOnly, onUpdateTitle, actions = null }) => {
  const { sidebarCollapsed, setSidebarCollapsed } = useSidebar();
  const [localTitle, setLocalTitle] = useState(title);

  useEffect(() => {
    setLocalTitle(title);
  }, [title]);

  const handleTitleChange = useCallback(
    (newTitle) => {
      setLocalTitle(newTitle);
      onUpdateTitle(newTitle);
    },
    [onUpdateTitle]
  );

  return (
    <HeaderContainer>
      {sidebarCollapsed && (
        <StyledSidebarToggleButton collapsed onClick={() => setSidebarCollapsed(false)} />
      )}
      <HeaderInfoContainer>
        <EditableTitle
          title={localTitle}
          onTitleChange={handleTitleChange}
          isReadOnly={isReadOnly}
        />
      </HeaderInfoContainer>

      <HeaderActionsContainer>{actions}</HeaderActionsContainer>
    </HeaderContainer>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
  onUpdateTitle: PropTypes.func.isRequired,
  actions: PropTypes.node,
  isReadOnly: PropTypes.bool.isRequired
};

export { Header };
